<template>
  <div class="login-wrap">
    <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm login-container">
      <div class="el-logo-img">
        <img src="../../static/img/login02.png">
      </div>
      <!-- <h3 class="title">欢迎来到松佰商城<span>商户平台</span></h3> -->

      <el-form-item prop="username">
        <div class="el-input-zh">
          <el-input type="text" v-model="ruleForm.username" auto-complete="off" placeholder="请输入用户名"></el-input>
          <span><img src="../../static/img/username.svg"></span>
        </div>
      </el-form-item>

      <el-form-item prop="pwd">
        <div class="el-input-zh">
          <el-input type="password" v-model="ruleForm.pwd" auto-complete="off" placeholder="请输入密码"></el-input>
          <span><img src="../../static/img/password.svg"></span>
        </div>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="validateCode">
            <div class="el-input-yzm">
              <el-input type="text" v-model="ruleForm.validateCode" auto-complete="off" placeholder="请输入红色验证码" @keyup.enter.native="submitForm('ruleForm')"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="code-box">
          <img :src="codeimg" alt="" class="codeimg" @click="getcode()">
        </el-col>
      </el-row>
      <div class="el-button-nue">
        <el-form-item style="width:100%;">
          <el-button type="primary" style="width:180px;" @click="submitForm('ruleForm')" :loading="logining">立即登录</el-button>
        </el-form-item>
      </div>
    </el-form>
    <div class="bottom-text">湖南展博科技发展有限公司 版权所有</div>
  </div>
</template>
<script type="text/ecmascript-6">
  import { login,verification } from '../api/userMG'
  import axios from 'axios';
  import { setCookie, getCookie, delCookie } from '../utils/util'
  import md5 from 'js-md5'
  export default {
    name: 'login',
    data() {
      return {
        //定义loading默认为false
        logining: false,
        ruleForm: {
          //username和password默认为空
          username: '',
          pwd: '',
          validateCode: ''
        },
        codeimg:'',
        //rules前端验证
        rules: {
          username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
          pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          validateCode: [{ required: true, message: '请填写红色数字', trigger: 'blur' }]
        },
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      // 获取图形验证码
      this.getcode()
      // 获取存在本地的用户名密码
      this.getuserpwd()
    },
    // 里面的函数只有调用才会执行
    methods: {
      getcode() {
        axios({
          method: 'get',
          url: '/api/common/verification',
          headers: {
            'Content-Type': 'application/json;charset:utf-8',
          },
          data: {},
          traditional: true,
          responseType: 'blob',
        }).then(res => {
          localStorage.setItem('verificationid',res.headers.verificationid)
          this.codeimg = window.URL.createObjectURL(res.data);
        });
      },
      // 获取用户名密码
      getuserpwd() {
        if (getCookie('user') != '' && getCookie('pwd') != '') {
          this.ruleForm.username = getCookie('user')
          this.ruleForm.pwd = getCookie('pwd')
        }
      },
      //获取info列表
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.logining = true
            // 测试通道，不为空直接登录
            // setTimeout(() => {
            //   this.logining = false
            //   this.$store.commit('login', 'true')
            //   this.$router.push({ path: '/dashboard/Dashboard' })
            // }, 1000)
            // 注释
            let data = {
              username: this.ruleForm.username,
              pwd:this.ruleForm.pwd,
              validateCode: this.ruleForm.validateCode,
            }
            login(data).then(res => {
              if (res.success) {
                if (this.rememberpwd) {
                  //保存帐号到cookie，有效期7天
                  setCookie('user', this.ruleForm.username, 7)
                  //保存密码到cookie，有效期7天
                  setCookie('pwd', this.ruleForm.pwd, 7)
                } else {
                  delCookie('user')
                  delCookie('pwd')
                }
                //如果请求成功就让他2秒跳转路由
                setTimeout(() => {
                  this.logining = false
                  // 缓存token
                  // localStorage.setItem('logintoken', res.content.token_id)
                  localStorage.setItem('userName', res.content.user_name)
                  localStorage.setItem('lastLoginTime', res.content.last_login_time)
                  localStorage.setItem('songbai_system', res.content.songbai_system)
                  localStorage.setItem('isClickClose','0')
                  localStorage.setItem('agent_type', res.content.agent_type)
                  localStorage.setItem('exclusiveMall', res.content.exclusive_mall)
                  this.$store.commit('login', 'true')
                  this.$store.commit('setTokenId', res.content.token_id)
                  this.$store.commit('setCustId', res.content.cust_id)
                  this.$router.push({ path: '/dashboard/Dashboard' })
                  localStorage.setItem('path','/dashboard/Dashboard')
                  this.$message({
                    type: 'success',
                    message: '登录成功!'
                  })
                }, 1000)
              } else {
                this.$message.error(res.msg)
                this.getcode()
                this.logining = false
                return false
              }
            })
          } else {
            // 获取图形验证码
            this.getcode()
            this.$message.error('请输入用户名密码！')
            this.logining = false
            return false
          }
        })
      },
    }
  }
</script>

<style scoped>
  .login-wrap {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding-top: 10%;
    background-image: url("/static/img/login_bg.png");
    /* background-color: #112346; */
    background-repeat: no-repeat;
    background-position: center right;
    background-size: 100%;
  }
  .login-container {
    background: #FFFFFF;
    box-shadow: 0px 10px 40px rgba(0, 133, 208, 0.3);
    border-radius: 12px;
    margin: 0px auto;
    width: 375px;
    padding: 44px 34px;
    text-align: left;
  }
  /deep/ .el-form-item {
    margin-bottom: 30px !important;
  }

  /deep/ .el-button-nue .el-form-item__content {
    text-align: center !important;
  }
  /deep/ .el-button-nue .el-button--primary {
    background: linear-gradient(90deg, #0B7BD9 0%, #12BEFF 100%) !important;
    border-radius: 12px !important;
  }
  .title {
    margin: 0px auto 50px auto;
    text-align: center;
    color: #333333;
  }
  .title span {
    color: #00A5E3;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
  .code-box {
    text-align: right;
  }
  .codeimg {
    height: 40px;
  }
  .el-logo-img {
    width: 335px;
    height: 47px;
    margin: 0 auto 30px;
  }
  .el-logo-img img {
    width: 100%;
  }

  .el-input-zh {
    position: relative;
    background: #F4F4F4;
    border-radius: 8px;
    padding: 0 56px 0 0;
  }
  /deep/ .el-input-zh .el-input__inner {
    border: 0 !important;
    background: #f4f4f4 !important;
    border-radius: 8px !important;
    padding: 0 0 0 15px !important;
  }
  .el-input-yzm {
    background: #F4F4F4;
    border-radius: 8px;
  }
  /deep/ .el-input-yzm .el-input__inner {
    border: 0 !important;
    background: #f4f4f4 !important;
    border-radius: 8px !important;
  }
  .el-input-zh span {
    position: absolute;
    width: 24px;
    height: 24px;
    top: 8px;
    right: 16px;
  }
  .el-input-zh span img {
    width: 100%;
  }
  .bottom-text {
    position: fixed;
    left: 50%;
    bottom: 30px;
    color: #fff;
    font-size: 14px;
    transform: translateX(-50%);
  }

</style>



// WEBPACK FOOTER //
// src/views/login.vue